import React, { FunctionComponent, useEffect, useState } from "react"
import appService from "./AppService"
import { MsalProvider } from '@azure/msal-react'
import stateService from "./utilities/AsyncStateManager/StateService"
import I_AppState from "./I_AppState"
import Authenticated from "./auth/authenticated/Authenticated"
import Unautheticated from "./auth/unauthenticated/Unautheticated"
import msalInstance from "./utilities/msalConfig"
import { useHistory } from "react-router-dom"
import { startStatusPoller } from './store/ServerStatus/actions';
import store from './store/store';

const App: FunctionComponent<{}> = () => {
    const history = useHistory()
    const accounts = msalInstance.getAllAccounts()
    const { updateState, manageSubscriptionAndStateUpdate } = stateService
    const [state, setState] = useState<I_AppState>(stateService.state.appState)
    const { authenticated } = state

    const aquireSilentToken = async (account: any) => {

        const { authenticateWithPortalAPI } = appService

        try {
            await msalInstance.initialize()
            const silentRequest = {
                scopes: [process.env.REACT_APP_MSAL_INSTANCE_SCOPES as string],
                account: account
            }

            msalInstance.acquireTokenSilent(silentRequest)
                .then((res: { accessToken: string }) => {
                    authenticateWithPortalAPI(res.accessToken, history)
                })
                .catch((err: any) => {
                    console.error(err)
                    localStorage.clear()
                    updateState("appState", [{ key: "loggingIn", value: false }])
                })
        } catch (err) {
            console.error(err)
            localStorage.clear()
            updateState("appState", [{ key: "loggingIn", value: false }])
        }
    }

    useEffect(() => {

        const { setUpApp } = appService

        const unsubscribe = manageSubscriptionAndStateUpdate(setState, "appState")

        setUpApp()
        const stopPoller = store.dispatch(startStatusPoller() as any)

        const init = async () => {
            if (accounts.length === 1) {
                aquireSilentToken(accounts[0])
            } else {
                updateState("appState", [{ key: "loggingIn", value: false }])
            }
        }

        init()

        return () => {
            unsubscribe()
            stopPoller()
        }
    }, [])

    // console.log(state.rolesAndAssignments)

    return (
        <div className="App">
            <MsalProvider instance={msalInstance}>
                {authenticated && <Authenticated />}
                {!authenticated && <Unautheticated />}
            </MsalProvider>
        </div>
    )
}

export default App
